import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    CererePriorityAddPayload, CererePriorityEditPayload,
} from './cerere-priority.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CererePriorityService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;
    private getCererePrioritiesUrl = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.list;
    private getCererePriorityDT = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.listDT;
    private storeCererePriorityURL = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.store;
    private updateStoreCererePriority = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.update;
    private deleteStoreCererePriority = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.delete;
    private getCererePrioritiesActive = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.listActive;
    private getCererePrioritiesPublic = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.listPublic;
    private changeStatusCererePrioritiesActiveUrl = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.active;
    private changeStatusCererePrioritiesPublicUrl = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.public;

    private clearCacheUrl = this.basePath + environment.interop.deps.nomenclatoare.cererePriority.clearCache;

    constructor(private http: HttpClient) { }

    getCererePrioritiesDT() {
        return this.http.get(this.getCererePriorityDT, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    addCererePriority(cererePriority: CererePriorityAddPayload) {
        return this.http.post(
            this.storeCererePriorityURL,
            cererePriority,
            this.httpOptions
        );
    }

    updateCererePriority(cererePriority: CererePriorityEditPayload) {
        return this.http.put(
            this.updateStoreCererePriority,
            cererePriority,
            this.httpOptions
        );
    }

    deleteCererePriority(id: number) {
        return this.http.delete(this.deleteStoreCererePriority + id);
    }

    getActiveCererePriorities() {
        return this.http.get(this.getCererePrioritiesActive, this.httpOptions);
    }

    getPublicCererePriorities() {
        return this.http.get(this.getCererePrioritiesPublic, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusCererePrioritiesActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusCererePrioritiesPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        };
    }
}
